// Import React Components
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// Import Material UI Elements
import { makeStyles } from "@material-ui/core/styles";
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import { Drawer } from "@material-ui/core";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
// Import Additional Packages
import clsx from "clsx";

// Import CSS Files
import "../Navbar/sideNavigationBar.css";
import "./sidebar.css";

// Import Custom Components
import Logo from "./Logo/logo";
import MenuItem from "./MenuItem/menuItem";

const DRAWER_WIDTH = 200;

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        zIndex: "1205",
    },
    drawer: { Width: DRAWER_WIDTH, flexShrink: 0, whiteSpace: "nowrap", overFlowX: "hidden" },
    drawerOpen: {
        backgroundColor: "transparent",
        width: DRAWER_WIDTH
    },
    drawerClose: {
        backgroundColor: "transparent",
        overflowX: "hidden",
        width: 85,
    }
}));

function Sidebar(props) {
    const classes = useStyles();
    const [toggleDrawer, setToggleDrawer] = useState(
        props.sideBarOpen ? props.sideBarOpen : false
    );
    const [selectedIndex, setSelectedIndex] = useState(-1); // list item selected
    const { t } = useTranslation();

    useEffect(() => {
        if (
            window.location.pathname === "/" ||
            window.location.pathname.includes("/dashboard")
        ) {
            setSelectedIndex(0);
        }
    }, []);

    const handleDrawer = (e, isOpen) => {
        let isFlowPage = window.location.pathname;
        if (
            isFlowPage.indexOf("autom/edit") !== -1 ||
            isFlowPage.indexOf("process/edit") !== -1
        ) {
            setToggleDrawer(isOpen);
            props.setSideBarOpen(isOpen);
        }
    };

    const handleClose = (e, isClose) => {
        setToggleDrawer(isClose);
        if (isClose) {
            props.setSideBarOpen(true);
        } else {
            props.setSideBarOpen(false);
        }
    }

    return (
        <div className={classes.root} data-test="sidebar-comp">
            <Drawer
                variant="permanent"
                className={clsx(classes.drawer, {
                    [classes.drawerOpen]: toggleDrawer,
                    [classes.drawerClose]: !toggleDrawer,
                })}
                classes={{
                    paper: clsx({
                        [classes.drawerOpen]: toggleDrawer,
                        [classes.drawerClose]: !toggleDrawer,
                    }),
                }}
            >
                <div
                    className="drawer-sidebar"
                    onMouseEnter={(e) => handleDrawer(e, true)} onMouseLeave={e => handleDrawer(e, false)}
                >
                    <div draggable={false} style={{ height: "100%" }}>
                        <Logo sidebarOpen={props.sideBarOpen} />
                        <div className={`sidebar-toggler ${props.sideBarOpen ? "close-sidebar" : "open-sidebar"}`}
                            onClick={(e) => handleClose(e, !toggleDrawer)}>
                            {props.sideBarOpen ? <ArrowBackIosIcon style={{ color: "#fff", fontSize: 12 }} /> :
                                <ArrowForwardIosIcon style={{ color: "#fff", fontSize: 12 }} />}
                        </div>
                        <MenuItem sideBarOpen={props.sideBarOpen} setSideBarOpen={props.setSideBarOpen}
                            setToggleDrawer={setToggleDrawer} toggleDrawer={toggleDrawer} asm={props.asm} />
                    </div>
                    {/*<div className={!toggleDrawer ? "toggle-button-vertical" : "toggle-button"}>*/}
                    {/*    <div onClick={(e) => handleClose(e, !toggleDrawer)} className="left-sidebar-open-menu-button"*/}
                    {/*         style={{marginTop: toggleDrawer && "20px"}}>*/}
                    {/*        <MenuOpenIcon className="menu-open-icon"/>*/}
                    {/*        {toggleDrawer && "Close Menu"}*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
            </Drawer>
        </div>
    );
}

export default Sidebar;
